<div class="container-fluid bg-white py-3 px-3">
  <div class="text-center" *ngIf="loading && !errorLoading">
    <i class="fas fa-spinner fa-pulse fa-3x"></i>
  </div>
  <div class="text-center" *ngIf="errorLoading">
    <div class="alert alert-danger"><i class="fas fa-times"></i>&nbsp;Error loading document, please try reloading this tab and refreshing this page. Contact tech if the issue persists.</div>
  </div>
  <div *ngIf="!loading && !errorLoading">
    <div class="document-show-layout d-flex">
      <div class="document-show-main">
        <div>
          <div class="matter-sb-header" (click)="leftSectionExpand.outgoing_documents = !leftSectionExpand.outgoing_documents">
            <h5 class="font-weight-normal">
              <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (leftSectionExpand.outgoing_documents ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Outgoing Documents -
              <small>
                <app-badge badgeType="primary">
                  {{ docShow.outgoing_documents.length }}
                </app-badge>
              </small>
            </h5>
          </div>
          <div class="matter-sb-content p-2" *ngIf="leftSectionExpand.outgoing_documents">
            <table class="table table-sm table-bordered" *ngIf="docShow.outgoing_documents.length > 0">
              <thead>
                <tr>
                  <th>Job</th>
                  <th>Destination</th>
                  <th>Result</th>
                  <th>Sent</th>
                  <th>Way</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let outgoing_document of docShow.outgoing_documents">
                  <td>
                    <a [href]="'/outgoing_jobs/' + outgoing_document.outgoing_job_id">{{ outgoing_document.outgoing_job_id }}</a>
                  </td>
                  <td>{{ outgoing_document.destination }}</td>
                  <td>{{ outgoing_document.result }}</td>
                  <td>{{ outgoing_document.sent_at }}</td>
                  <td>{{ outgoing_document.way }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div>
          <div class="matter-sb-header" (click)="leftSectionExpand.matter_histories = !leftSectionExpand.matter_histories">
            <h5 class="font-weight-normal" style="line-height: 24px">
              <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (leftSectionExpand.matter_histories ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Matter Histories
            </h5>
          </div>
          <div class="matter-sb-content p-2" *ngIf="leftSectionExpand.matter_histories">
            <div *ngIf="docShow.matter_history.matter_history_type_name">
              <h5 class="mt-1 mb-2">Matter History</h5>
              <div class="row">
                <div class="col-3">{{ docShow.matter_history.matter_history_type_name }}</div>
                <div class="col-9" [innerHTML]="docShow.matter_history.message | safeHtml"></div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="matter-sb-header" (click)="leftSectionExpand.fileshare_histories = !leftSectionExpand.fileshare_histories">
            <h5 class="font-weight-normal">
              <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (leftSectionExpand.fileshare_histories ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Fileshare Histories -
              <small>
                <app-badge badgeType="primary">
                  {{ docShow.shared_history.length }}
                </app-badge>
              </small>
            </h5>
          </div>
          <div class="matter-sb-content" *ngIf="leftSectionExpand.fileshare_histories">
            <div *ngIf="docShow.shared_history.length > 0">
              <div class="row" *ngFor="let sharedHistory of docShow.sharedHistory">
                <div class="col-12">
                  <h5 class="mt-1 mb-2">{{ sharedHistory[0].name }}</h5>
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>IP Address</th>
                        <th>Document</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let detail of sharedHistory[0].details">
                        <td>{{ detail.datetime }}</td>
                        <td>{{ detail.ip }}</td>
                        <td>
                          <a *ngIf="detail.download_path" [href]="detail.download_path">{{ detail.document_name }}</a>
                          <app-badge badgeType="warning">
                            Document link missing
                          </app-badge>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="matter-sb-header" (click)="leftSectionExpand.versions = !leftSectionExpand.versions">
            <h5 class="font-weight-normal">
              <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (leftSectionExpand.versions ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Versions -
              <small>
                <app-badge badgeType="primary">
                  {{ docShow.versions.length }}
                </app-badge>
              </small>
            </h5>
          </div>
          <div class="matter-sb-content" *ngIf="leftSectionExpand.versions">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th>Version</th>
                  <th>Date</th>
                  <th>Preview</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let version of docShow.versions">
                  <td>{{ version.version }}</td>
                  <td>{{ version.created_at }}</td>
                  <td>
                    <a class="btn btn-outline-secondary btn-sm" [href]="'/documents/' + docShow.id + '/preview_document_version/?version=' + version.version" target="_blank">Preview</a>
                  </td>
                  <td>
                    <button type="button" *ngIf="version.version != docShow.version || docShow.autosaved" [disabled]="docShow.reverting" (click)="setDocumentVersion(version)" class="btn btn-outline-secondary btn-sm">Revert</button>
                    <span class="text-primary" *ngIf="version.version == docShow.version && !docShow.autosaved">Live version</span>
                  </td>
                  <td></td>
                </tr>

                <tr *ngIf="docShow.autosaved">
                  <td>N/A</td>
                  <td></td>
                  <td>
                    <a class="btn btn-outline-secondary btn-sm" [href]="'/documents/' + docShow.id + '/preview_document_version/?autosaved=1'" target="_blank">Preview</a>
                  </td>
                  <td><span class="text-warning">Autosaved</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div>
          <div class="matter-sb-header" (click)="leftSectionExpand.view_document = !leftSectionExpand.view_document">
            <h5 class="font-weight-normal" style="line-height: 24px">
              <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (leftSectionExpand.view_document ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;View Document
            </h5>
          </div>
          <div class="matter-sb-content" *ngIf="leftSectionExpand.view_document">
            <div class="mb-2" *ngIf="docShow.file_exists">
              <button type="button" class="btn btn-sm btn-outline-primary" (click)="downloadDocument($event)"><i class="fas fa-download"></i> Download</button>
            </div>
            <div class="document-html-preview py-4 px-4" *ngIf="docShow.is_editable && docShow.document_html" [innerHTML]="docShow.document_html | safeHtml"></div>
            <div class="text-center py-5" *ngIf="docShow.file_exists && documentViewUrl && !(docShow.is_editable && docShow.document_html)">
              <iframe [src]="documentViewUrl | safeUrl" style="width: 100%; height: 30cm"></iframe>
            </div>
            <div class="text-center py-5" *ngIf="!docShow.file_exists">
              <h3 class="text-danger">File missing</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="pl-3 document-show-sidebar">
        <div>
          <div class="matter-sb-header" (click)="rightSectionExpand.authors = !rightSectionExpand.authors">
            <h5 class="font-weight-normal">
              <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (rightSectionExpand.authors ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Authors -
              <small>
                <app-badge badgeType="primary">
                  {{ docShow.document_authors.length }}
                </app-badge>
              </small>
            </h5>
          </div>
          <div class="matter-sb-content" *ngIf="rightSectionExpand.authors">
            <div class="row" *ngIf="!viewAuthorMode">
              <div class="col-1"></div>
              <div class="col-10">
                <table class="table table-sm">
                  <tbody>
                    <tr>
                      <td colspan="2" class="pb-2" *ngIf="matterStoreService.documentEditor || matterStoreService.documentUploader">
                        <div class="input-group input-group-sm">
                          <div class="input-group-prepend"><span class="input-group-text">Add Author</span></div>
                          <input
                            #authorSearchInput
                            type="text"
                            class="form-control"
                            [data]="{ autocomplete: true, id: doc.id }"
                            placeholder="Search for author"
                            [appAutocomplete]="'/documents/get_document_authors_available'"
                            [include_item]="true"
                            (autocompleteSelect)="onAuthorSelect($event)"
                            [disabled]="addingAuthor"
                          />
                        </div>
                      </td>
                    </tr>
                    <tr *ngFor="let author of docShow.document_authors; let i = index">
                      <td>
                        <a [href]="'/contacts/' + author.contact_id" target="_blank">{{ author.list_name }}</a>
                      </td>
                      <td>
                        <div class="btn-group btn-group-sm p-0">
                          <button type="button" [disabled]="removingAuthor" (click)="removeAuthor(author, i)" title="Remove author" class="btn btn-outline-danger" *ngIf="matterStoreService.documentEditor || matterStoreService.documentUploader">
                            <i class="fas fa-trash"></i>
                          </button>
                          <button type="button" (click)="viewAuthor(author)" title="View author" class="btn btn-outline-primary">
                            <i class="far fa-folder-open"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row p-2" *ngIf="viewAuthorMode">
              <div class="col-12">
                <div class="float-left">
                  <button type="button" class="btn btn-link btn-sm" (click)="closeViewAuthor()"><i class="fas fa-arrow-left"></i></button>
                </div>
                <div class="clearfix"></div>
                <h5 class="py-1 text-center">
                  <a [href]="'/contacts/' + authorBeingViewed.contact_id" target="_blank">{{ authorBeingViewed.list_name }}</a>
                </h5>
                <h5 class="py-1 text-center" *ngIf="authorBeingViewed.employer && authorBeingViewed.employer.length > 0">{{ authorBeingViewed.employer }}</h5>
                <table class="table table-sm">
                  <tbody>
                    <tr>
                      <th scope="row">Phone Numbers</th>
                      <td>
                        <div class="p-1 m-1 bg-success text-white" *ngFor="let phone_number of authorBeingViewed.phone_numbers"><a appPhoneCallBilling [phoneCallContactName]="authorBeingViewed.name || ''" [href]="'tel:' + phone_number.number" class="text-white" title="Call {{ phone_number.number }}"><i class="fas fa-phone fa-xs"></i>&nbsp;{{ phone_number.number }}</a></div>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Addresses</th>
                      <td>
                        <div class="p-1 m-1 bg-info text-white" *ngFor="let address of authorBeingViewed.addresses">{{ address.address }}</div>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Email Addresses</th>
                      <td>
                        <div class="p-1 m-1 bg-primary text-white" *ngFor="let emailAddress of authorBeingViewed.email_addresses">{{ emailAddress.email }}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="matter-sb-header" (click)="rightSectionExpand.clone = !rightSectionExpand.clone">
            <h5 class="font-weight-normal" style="line-height: 24px">
              <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (rightSectionExpand.clone ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Clone
            </h5>
          </div>
          <div class="matter-sb-content pl-5 pr-3" *ngIf="rightSectionExpand.clone">
            <div class="row">
              <div class="col">
                <button (click)="clone()" [disabled]="cloning" type="button" class="btn btn-primary">
                  {{ cloning ? 'Cloning document' : 'Clone document' }}<span *ngIf="cloning">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="custom-control custom-checkbox" (click)="cloneOptions.document_authors = !cloneOptions.document_authors">
                  <input type="checkbox" class="custom-control-input" [(ngModel)]="cloneOptions.document_authors" [checked]="cloneOptions.document_authors" />
                  <label class="custom-control-label">Document authors</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="custom-control custom-checkbox" (click)="cloneOptions.document_attachments = !cloneOptions.document_attachments">
                  <input type="checkbox" class="custom-control-input" [(ngModel)]="cloneOptions.document_attachments" [checked]="cloneOptions.document_attachments" />
                  <label class="custom-control-label">Document attachments</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="custom-control custom-checkbox" (click)="cloneOptions.document_to_contacts = !cloneOptions.document_to_contacts">
                  <input type="checkbox" class="custom-control-input" [(ngModel)]="cloneOptions.document_to_contacts" [checked]="cloneOptions.document_to_contacts" />
                  <label class="custom-control-label">Document To contacts</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="custom-control custom-checkbox" (click)="cloneOptions.document_cc_contacts = !cloneOptions.document_cc_contacts">
                  <input type="checkbox" class="custom-control-input" [(ngModel)]="cloneOptions.document_cc_contacts" [checked]="cloneOptions.document_cc_contacts" />
                  <label class="custom-control-label">Document CC contacts</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="custom-control custom-checkbox" (click)="cloneOptions.document_bcc_contacts = !cloneOptions.document_bcc_contacts">
                  <input type="checkbox" class="custom-control-input" [(ngModel)]="cloneOptions.document_bcc_contacts" [checked]="cloneOptions.document_bcc_contacts" />
                  <label class="custom-control-label">Document BCC contacts</label>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <label class="col-form-label">To another matter</label>
                <app-matter-search (matter_id)="cloneOptions.to_another_matter_id = $event" (clearMatter)="cloneOptions.to_another_matter_id = undefined"></app-matter-search>
                <small class="form-text text-muted"> Leave blank for current matter </small>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="matter-sb-header" (click)="rightSectionExpand.details = !rightSectionExpand.details">
            <h5 class="font-weight-normal" style="line-height: 24px">
              <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (rightSectionExpand.details ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Details
            </h5>
          </div>
          <div class="matter-sb-content" *ngIf="rightSectionExpand.details">
            <div class="row">
              <div class="col-1"></div>
              <div class="col-10">
                <table class="table table-sm">
                  <tbody>
                    <tr>
                      <th scope="row">Is Editable</th>
                      <td>
                        <i class="fas" [ngClass]="{ 'fa-check': docShow.is_editable, 'fa-times': !docShow.is_editable, 'text-success': docShow.is_editable, 'text-danger': !docShow.is_editable }"></i>
                        &nbsp;&nbsp;
                        <button type="button" [disabled]="docShow.settingEditability" *ngIf="docShow.is_allowed_to_edit" (click)="setEditability()" class="btn btn-outline-primary btn-sm">
                          Change to {{ docShow.is_editable ? 'not editable' : 'editable' }}
                          <span *ngIf="docShow.settingEditability"> &nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i> </span>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Authored at</th>
                      <td>{{ docShow.authored_at_str }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Created by</th>
                      <td>{{ docShow.created_by }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Created at</th>
                      <td>{{ docShow.created_at_str }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Updated by</th>
                      <td>{{ docShow.updated_by }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Updated at</th>
                      <td>{{ docShow.updated_at_str }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Document Type</th>
                      <td>{{ docShow.document_type.name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Form Type</th>
                      <td>{{ docShow.form_name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Exhibit #</th>
                      <td>{{ docShow.exhibit_id }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Version</th>
                      <td>{{ docShow.version }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Notes</th>
                      <td [innerHTML]="docShow.notes | safeHtml"></td>
                    </tr>
                    <tr>
                      <th scope="row">All Tags</th>
                      <td>
                        <span *ngFor="let tag of docShow.tag_list">
                          <app-badge badgeType="primary">
                            {{ tag }}
                          </app-badge>
                          &nbsp;
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Delete document</th>
                      <td>
                        <button class="btn btn-danger btn-sm" [disabled]="docShow.deleting" (click)="deleteDocument()"><i class="fas fa-trash"></i> Delete</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <hr />
                <fieldset>
                  <h4 class="mt-3 mb-0">Editable details</h4>
                  <hr class="my-2" />
                  <div class="form-group">
                    <div class="float-right">
                      <button type="button" class="btn btn-primary btn-sm" (click)="setDocumentType()" [disabled]="savingDocumentType">
                        {{ savingDocumentType ? 'Saving' : 'Save' }}<span *ngIf="savingDocumentType">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
                      </button>
                    </div>
                    <label>Document Type</label>
                    <app-document-type-search [include_item]="true" [documentTypeId]="docShow.document_type.id" (document_type)="documentType = $event"></app-document-type-search>
                  </div>
                  <hr class="my-2" />
                  <div class="form-group">
                    <div class="float-right">
                      <button type="button" class="btn btn-primary btn-sm" (click)="setExhibitNumber()" [disabled]="savingExhibitNumber">
                        {{ savingExhibitNumber ? 'Saving' : 'Save' }}<span *ngIf="savingExhibitNumber">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
                      </button>
                    </div>
                    <label>Exhibit Number</label>
                    <input type="text" class="form-control" [(ngModel)]="exhibitNumber" [disabled]="savingExhibitNumber" />
                  </div>
                  <hr class="my-2" />
                  <div class="form-group">
                    <div class="float-right">
                      <button type="button" class="btn btn-primary btn-sm" (click)="setAuthoredAt()" [disabled]="savingAuthoredAt">
                        {{ savingAuthoredAt ? 'Saving' : 'Save' }}<span *ngIf="savingAuthoredAt">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
                      </button>
                    </div>
                    <label>Authored on</label>
                    <input type="text" class="form-control" [appDatepicker]="docShow.authored_at_str" [disabled]="savingAuthoredAt" [(ngModel)]="authoredAt" (dateSelected)="authoredAt = $event" />
                  </div>
                  <hr class="my-2" />
                  <div class="form-group">
                    <div class="float-right">
                      <button type="button" class="btn btn-primary btn-sm" (click)="saveNotes()" [disabled]="savingNotes">
                        {{ savingNotes ? 'Saving' : 'Save' }}<span *ngIf="savingNotes">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
                      </button>
                    </div>
                    <label>Notes</label>
                    <textarea class="form-control" [(ngModel)]="notes" [disabled]="savingNotes"></textarea>
                  </div>
                </fieldset>
                <hr *ngIf="docShow && docShow.is_uploaded && docShow.is_allowed_to_upload && docShow.is_editable" />
                <fieldset *ngIf="docShow && docShow.is_uploaded && docShow.is_allowed_to_upload && docShow.is_editable">
                  <h4 class="mt-3 mb-0">
                    Upload
                    <br />
                    <small><small class="text-muted font-italic">(Overwrites previous upload)</small></small>
                  </h4>
                  <hr class="my-2" />
                  <div class="form-group">
                    <div class="custom-file" *ngIf="!resettingUpload">
                      <input type="file" class="custom-file-input" required ng2FileSelect [uploader]="uploader" name="file" placeholder="No file chosen" />
                      <label class="custom-file-label" for="customFile">{{ uploader && uploader.queue && uploader.queue[0] ? uploader.queue[0].file.name : 'File' }}</label>
                    </div>
                  </div>
                  <div class="form-group">
                    <button type="button" class="btn btn-sm btn-primary btn-block" [disabled]="uploadingFile" (click)="uploadDocument()">
                      {{ uploadingFile ? 'Uploading' : 'Upload' }} File
                      <span *ngIf="uploadingFile">
                        &nbsp;
                        <i class="fas fa-spinner fa-fw fa-pulse"></i>
                      </span>
                    </button>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="matter-sb-header" (click)="rightSectionExpand.rename = !rightSectionExpand.rename">
            <h5 class="font-weight-normal" style="line-height: 24px">
              <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (rightSectionExpand.rename ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Rename
            </h5>
          </div>
          <div class="matter-sb-content p-2" *ngIf="rightSectionExpand.rename">
            <h5 class="text-center py-1">{{ docShow.name }}</h5>
            <div class="form-group">
              <div class="input-group input-group">
                <div class="input-group-prepend"><span class="input-group-text">New name</span></div>
                <input type="text" class="form-control" [(ngModel)]="newName" />
              </div>
            </div>
            <div class="form-group text-center">
              <button type="button" class="btn btn-sm btn-primary" (click)="saveName('new_name')" [disabled]="renamingDocument">
                {{ renamingDocument && renamingDesire != 'restore_name' ? 'Saving' : 'Save' }}<span *ngIf="renamingDocument && renamingDesire != 'restore_name'">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
              </button>
              &nbsp;&nbsp;
              <button type="button" class="btn btn-sm btn-primary" (click)="saveName('restore_name')" [disabled]="renamingDocument">
                {{ renamingDocument && renamingDesire == 'restore_name' ? 'Restoring default' : 'Restore default' }}<span *ngIf="renamingDocument && renamingDesire == 'restore_name'">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
              </button>
            </div>
          </div>
        </div>
        <div>
          <div class="matter-sb-header" (click)="rightSectionExpand.tags = !rightSectionExpand.tags">
            <h5 class="font-weight-normal">
              <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (rightSectionExpand.tags ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Tags -
              <small>
                <app-badge badgeType="primary">
                  {{ docShow.tag_list.length }}
                </app-badge>
              </small>
            </h5>
          </div>
          <div class="matter-sb-content" *ngIf="rightSectionExpand.tags">
            <div class="row">
              <div class="col-1"></div>
              <div class="col-10">
                <table class="table table-sm">
                  <tbody>
                    <tr>
                      <td colspan="2" class="pb-2">
                        <div class="input-group input-group-sm">
                          <input type="text" class="form-control" placeholder="Enter tags here (comma separated)" [disabled]="addingTags" [(ngModel)]="newTags" />
                          <div class="input-group-append">
                            <button type="button" [disabled]="addingTags" class="btn btn-primary" (click)="addTag()">
                              {{ addingTags ? 'Adding Tags' : 'Add Tag(s)' }}<span *ngIf="addingTags">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr *ngFor="let tag of docShow.tag_list; let i = index">
                      <td>{{ tag }}</td>
                      <td>
                        <button type="button" [disabled]="removingTag" title="Remove tag" (click)="deleteTag(tag, i)" class="btn btn-outline-danger">
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
